module.exports = __webpack_public_path__ + "img/agreement-pic.7b634b08.png";